export default __webpack_public_path__ + "static/media/Rischio-di-ictus.7ce51530.svg";